import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { installAuthFetch } from './api/authFetch';
import { ThemeProvider } from './context/ThemeContext.jsx';
import { SettingsProvider } from './context/SettingsContext';
import { SessionProvider } from './context/SessionContext';
import { WebSocketProvider } from './context/WebSocketContext';
import { ToastProvider } from './context/ToastContext';
import { NavigationProvider } from './context/NavigationContext';
import './i18n';
// Single stylesheet entry point (spec §6.6): index.css owns the cascade-layer
// order and imports every sheet, including the legacy pre-Etch ones. Adding a
// second import here would reintroduce the import-order-dependent cascade the
// layers exist to remove.
import './styles/index.css';

// Before anything renders: the API requires an account on a set-up platform,
// and plenty of call sites reach it through a bare fetch(). See api/authFetch.js.
installAuthFetch();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <SettingsProvider>
          <SessionProvider>
            <WebSocketProvider>
              <ToastProvider>
                <NavigationProvider>
                  <App />
                </NavigationProvider>
              </ToastProvider>
            </WebSocketProvider>
          </SessionProvider>
        </SettingsProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
